<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <template>

      <!-- 管理者権限以外 -->
      <div class="top-contents" v-if="!isSystemAdmin && !isAllPermission">

        <div class="ls-name" v-if="isDiagAvailablePlan && !isAdmin">
          <p><span>管理法人：</span>{{ manageCorpName }}</p>
        </div>

        <div class="l-contents info">
          <LatestNoticeList
            :isDiagAvailablePlan="isDiagAvailablePlan"
          ></LatestNoticeList>
          <div class="info-btnlist" v-if="isDiagAvailablePlan">
            <div class="btn" @click="$router.push({ name: 'doc-list' })"><a><span class="icon"><img src="@/assets/img/common/icon-label1.svg" alt=""></span><span class="text"><span class="ttl">書式</span><span class="txt">労務管理に役立つ各種様式や申請ガイドなど。</span></span></a></div>
            <div class="btn" @click="$router.push({ name: 'corporate-list' })" v-if="isAdmin && isAdminUser"><a><span class="icon"><img src="@/assets/img/common/icon-label2.svg" alt=""></span><span class="text"><span class="ttl">法人一覧</span><span class="txt">クライアント法人の基本情報の確認・編集。</span></span></a></div>
            <div class="btn" @click="$router.push({ name: 'solution-list' })" v-if="isAdmin"><a><span class="icon"><img src="@/assets/img/common/icon-label3.svg" alt=""></span><span class="text"><span class="ttl">ソリューション</span><span class="txt">労務管理に役立つソリューションの紹介。</span></span></a></div>
          </div>
        </div>

        <template v-if="isDiagAvailablePlan">
          <LatestNoticeForOfficeList></LatestNoticeForOfficeList>
        </template>

        <!-- 専門家ユーザーのみ、監査対象一般法人が１件も登録されていないときに表示する項目 -->
        <div class="l-contents audit" v-if="noManageCorp">
          <div class="audit-main">
            <div class="inner t-center">
              <p v-if="!isSupple" class="l-text">ヨクスルは顧問先の労務状況を簡単にチェックし、改善にむけた課題の管理を行うことができるサービスです。<br>
                労務監査や人的資本管理などを行うには、顧問先の法人情報を登録する必要があります。<br>
                まずは、顧問先の法人情報を追加しましょう。<br>
                機能のお試しを行う場合はダミーの一般法人を作成してください。</p>
              <p v-else class="l-text">労務サプリは顧問先の労務状況を簡単にチェックできるサービスです。<br>
                ご利用いただくには、顧問先の法人情報を登録する必要があります。<br>
                まずは、顧問先の法人情報を追加しましょう。<br>
                機能のお試しを行う場合はダミーの一般法人を作成してください。</p>
              <div v-if="userAuthNo==3" class="btn-basic is-inlne is-primary mt-30" @click="goInput('')" :disabled="isProcessing"><a>法人の新規作成</a></div>
            </div>
          </div>
        </div>

        <div v-if="!noManageCorp">
          <div class="l-contents audit" v-if="!isSupple">

            <!-- 代理店 -->
            <div class="l-contents audit-contents" v-if="isProxy">
              <div class="audit-main">
                <div>
                  <div class="title1 has-top-company-select">
                    <h2>{{ corpNm }}</h2>
                    <div class="l-company__select_supple" @click="showCorporateList(true)" v-if="isAdmin">
                      <span>法人を切り替え</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="title1 is-company" v-if="!isSupple && !isProxy" @mouseenter="onCompanyEnter" @mouseleave="onCompanyLeave">
              <div class="l-company__wrap">
                <div class="l-company__left" v-show="isDiagAvailablePlan">
                  <p class="l-company__name" >{{ corpNm }}</p>
                  <div class="l-company__feature" @mouseenter="onFeatureEnter">
                    <span>特徴を表示</span>
                    <div class="l-company__detail">
                      <CorporateFeatureInfoLabel
                        :isProxy="isProxy"
                        :corporateFeatureInfoLabels="this.corporateFeatureInfoLabels"
                      ></CorporateFeatureInfoLabel>
                    </div>
                  </div>
                  <!-- 事業場情報(ホバーでプレビュー) -->
                  <div class="l-company__workspace" @mouseenter="onWorkspaceEnter">
                    <span>事業場情報</span>
                  </div>
                  <nav class="l-company-nav" @mouseenter="onFeatureEnter">
                    <ul v-if="isAdmin">
                      <li class="is-current">
                        <a class="l-company-nav__link is-dashboard" @click="goTop()">カルテ</a>
                      </li>
                      <li class="<?php if(strpos($_name,'KAN') !== false){ echo 'is-current';} ?>">
                        <a class="l-company-nav__link is-labor-audit" @click="goDiagTop()">労務監査</a>
                      </li>
                      <li class="<?php if(strpos($_name,'JIN') !== false){ echo 'is-current';} ?>">
                        <a class="l-company-nav__link is-human-capital" @click="goHumanCapital()">人的資本管理</a>
                      </li>
                      <li class="<?php if(strpos($_name,'MIN') !== false){ echo 'is-current';} ?>">
                        <a class="l-company-nav__link is-mini-test" @click="goRoughDiagTop()">小テスト</a>
                      </li>
                      <li class="<?php if(strpos($_name,'COP') !== false){ echo 'is-current';} ?>" v-if="isAdminUser">
                        <a class="l-company-nav__link is-company"  @click="goCorporate()">法人情報</a>
                      </li>
                    </ul>
                    <ul v-if="!isAllPermission && !isSystemAdmin && !isAdmin">
                      <li class="is-current">
                        <a class="l-company-nav__link is-dashboard" @click="goTop()">カルテ</a>
                      </li>
                      <li class="<?php if(strpos($_name,'KAN') !== false){ echo 'is-current';} ?>">
                        <a class="l-company-nav__link is-labor-audit" @click="goDiagTop()">労務監査</a>
                      </li>
                      <li class="<?php if(strpos($_name,'JIN') !== false){ echo 'is-current';} ?>">
                        <a class="l-company-nav__link is-human-capital" @click="goHumanCapital()">人的資本管理</a>
                      </li>
                      <li class="<?php if(strpos($_name,'MIN') !== false){ echo 'is-current';} ?>">
                        <a class="l-company-nav__link is-mini-test" @click="goRoughDiagTop()">小テスト</a>
                      </li>
                    </ul>
                  </nav>
                </div> <!-- l-company__left end -->
                <div class="l-company__right">
                  <div v-show="isDiagAvailablePlan || isSupple">
                    <div class="l-company__select" @click="showCorporateList(true)" v-if="isAdmin">
                      <span>法人を切り替え</span>
                    </div>
                  </div>
                </div> <!-- l-company__right end -->
              </div> <!-- l-company__wrap end -->

              <!-- 事業場情報プレビュー(ホバー表示・読み取り専用) -->
              <div class="ws-modal" :class="{ 'is-show': isShowWorkplaceModal }">
                <div class="ws-modal__dialog">
                  <div v-if="wsWorkplaces.length > 0" class="ws-modal__scroll-wrap">
                    <div class="ws-tbl">
                      <div class="ws-row ws-row--head">
                        <div class="ws-col ws-col--label">届出項目 / 事業場リスト</div>
                        <div class="ws-col ws-col--place is-header" v-for="wp in wsWorkplaces" :key="wp.workplaceId">
                          <div class="ws-place-name"><span>{{ wp.workplaceName }}</span></div>
                          <span class="ws-employee-badge">{{ wsEmpLabel(wp.employeesType) }}</span>
                        </div>
                      </div>
                      <div class="ws-row ws-row--note">
                        <div class="ws-col ws-col--label"><span class="ws-note-icon"></span>備考</div>
                        <div class="ws-col ws-col--place" v-for="wp in wsWorkplaces" :key="wp.workplaceId">
                          <span v-if="wp.remarks" class="ws-note-text" style="white-space: pre-wrap;">{{ wp.remarks }}</span>
                          <span v-else class="ws-note-placeholder">備考なし</span>
                        </div>
                      </div>
                      <div
                        v-for="item in wsItems"
                        :key="item.workplaceNotificationItemId"
                        class="ws-row ws-row--item"
                        :class="item.judgmentType === 1 ? 'ws-row--auto' : 'ws-row--manual'"
                      >
                        <div class="ws-col ws-col--label">
                          <span class="ws-item-name">{{ item.notificationName }}<small v-if="item.supplement">{{ item.supplement }}</small></span>
                        </div>
                        <div
                          class="ws-col ws-col--place"
                          :class="{ 'is-alert': wsCell(wp.workplaceId, item.workplaceNotificationItemId).alert }"
                          v-for="wp in wsWorkplaces"
                          :key="wp.workplaceId"
                        >
                          <span class="ws-status-label" :class="wsCell(wp.workplaceId, item.workplaceNotificationItemId).cls">{{ wsCell(wp.workplaceId, item.workplaceNotificationItemId).text }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="l-contentsBox l-resultBox">
                    <h3 class="l-headding is-blue">事業場の情報が登録されていません。<template v-if="canEditWorkplace"><br>法人情報 から事業場を登録してください。</template></h3>
                    <div v-if="canEditWorkplace" class="btn-basic is-inlne is-primary mt-30"><a @click="goWorkplaceList()">事業場を登録</a></div>
                  </div>
                </div>
              </div>
            </div> <!-- title1 is-company end -->

            <!-- 総合ランクメダル表示 -->
            <CorporateRank ref="corpRank" :corpId = "corpId" :diagResultId = "diagResultId" v-show="!isSupple && !isProxy && !isOptionDiag"/>

            <div class="l-contents audit-contents">
              <div class="audit-main">

                <!-- メモ表示部　開始　-->
                <div v-show="!isSupple && memo!='undefined'">
                  <div class="title2 top-memo-title">
                    <h2><img src="@/assets/img/memo/icon-memo.svg" alt="" width="22" height="22">{{this.memo.title}}</h2>
                    <button class="top-memo__edit-btn" @click="memoOpen" ><img src="@/assets/img/memo/icon-edit-blue.svg" alt="">編集</button>
                  </div>
                  <div class="top-memo has-attachment">
                    <div class="top-memo__body">
                      <p id="memoDetailBodyContent" class="l-text" style="white-space: pre-line;" v-html="repalceLink(this.memo.body)"></p>
                    </div>
  <!--                  <div class="top-memo__attachment">
                      <h3 class="top-memo__attachment-title">添付ファイル</h3>
                      <ul>
                        <li class="memo-footer__attachment-link" v-for="(attachment,key) in memo.attachments" :key="key"><a href="#">{{attachment.name|omittedFileName}}</a></li>
                      </ul>
                    </div>
  -->
                  </div>
                </div>
                <!-- メモ表示部　終了　-->

                <!--
                  労務サプリの場合は「監査」は不要だが「法人を切り替え」のみ表示したい
                  (労務サプリのisDiagAvailablePlanはfalse)
                -->
                <div v-show="isDiagAvailablePlan || isSupple">
                  <div v-if="!isSupple">
                    <div class="title2">
                      <h2><img src="@/assets/img/common/icon-nav1.svg" alt="" width="22" height="22">監査</h2>
                      <div class="btn-create-new" @click="goNewDiag()"><a>監査の新規作成</a></div>
                    </div>
                    <LatestDiagResult
                      ref="latestDiagResult"
                      :isAdmin="isConsultant"
                      :isProxy="isProxy"
                      :isSupple="isSupple"
                      :isIpo="isIpo"
                      @emit-diag-title-change="changeDiagTitle"
                    ></LatestDiagResult>
                  </div>
                </div>

  <!--              <RoughDiagResultList ref="roughDiagResultList"></RoughDiagResultList>-->

                <div v-show="!isSupple && !isProxy">

                  <CorporateInfo ref="corpInfo" :corpId=this.corpId />

                  <div  class="title2" id="humanCapital"><h2><img src="@/assets/img/common/icon-nav8.svg" alt="" width="22" height="22">人的資本</h2></div>
                  <HumanCapitalSummary 
                    ref="hrSummary"
                    :corpId=this.corpId
                    @click-add-year="emitShowAddYearAlert"
                    @save-corp-setting="emitSaveCorpSetting"/>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- 管理法人なし　終わり -->
      </div> <!-- 管理者権限以外 終わり -->
      <!-- 管理者権限　始まり -->
      <div v-else class="l-contents">
        <h1></h1>
        <h1 class="l-pageTitle"><img src="@/assets/img/common/icon-setting.svg" alt="">管理メニュー</h1>
        <ul class="l-btn-admin">
          <li @click="goDiagMaster()">
            <a>
              <div class="icon"><img src="@/assets/img/common/icon-nav1_blue.svg" alt="" width="30" height="30"></div>
              <div>
                <span class="title">監査・小診断</span>
                <span class="text">診断項目、診断コース、小テストの追加・変更などを行うことができます。</span>
              </div>
            </a>
          </li>
          <li @click="goHumanCapitalMaster()">
            <a>
              <div class="icon"><img src="@/assets/img/common/icon-nav8_blue.svg" alt="" width="28" height="28"></div>
              <div>
                <span class="title">人的資本管理</span>
                <span class="text">解説、取り組みガイド、業界平均値の設定を行うことができます。</span>
              </div>
            </a>
          </li>
        </ul>
        <ul class="l-btn-admin">
          <li @click="goNoticeList()">
            <a>
              <div class="icon"><img src="@/assets/img/common/icon-nav6_blue.svg" alt="" width="30" height="30"></div>
              <div>
                <span class="title">お知らせ</span>
                <span class="text">お知らせの追加・変更などを行うことができます。</span>
              </div>
            </a>
          </li>
          <li @click="goSolutionMasterList()">
            <a>
              <div class="icon"><img src="@/assets/img/common/icon-nav5_blue.svg" alt="" width="30" height="30"></div>
              <div>
                <span class="title">ソリューションマスタ</span>
                <span class="text">ソリューションの追加・変更などを行うことができます。</span>
              </div>
            </a>
          </li>
          <li @click="goGuideList()">
            <a>
              <div class="icon"><img src="@/assets/img/common/icon-nav3_blue.svg" alt="" width="30" height="30"></div>
              <div>
                <span class="title">ガイド</span>
                <span class="text">ガイドの追加・変更などを行うことができます。</span>
              </div>
            </a>
          </li>
        </ul>
        <ul class="l-btn-admin">
          <li @click="goCorporateList()">
            <a>
              <div class="icon"><img src="@/assets/img/common/icon-nav7_blue.svg" alt="" width="28" height="28"></div>
              <div>
                <span class="title">法人一覧</span>
                <span class="text">法人の追加・変更などを行うことができます。</span>
              </div>
            </a>
          </li>
          <li @click="goTrialEntryList()">
            <a>
              <div class="icon"><img src="@/assets/img/common/icon-user_blue.svg" alt="" width="28" height="28"></div>
              <div>
                <span class="title">トライアル申込情報</span>
                <span class="text">トライアル申込情報の確認を行うことができます。</span>
              </div>
            </a>
          </li>
        </ul>
      </div>

      <transition name="corplist-fade">
        <CorporateListModal
          v-show="isShowCorporateList"
          @hide-corporate-list-modal="showCorporateList(false)"
          @select-corporate="emitSelectCorpList"
        ></CorporateListModal>
      </transition>
      <transition name="diagtitlechange-fade">
        <DiagTitleChangeModal
          v-show="execChangeDiagTitle"
          :diagResultId="diagResultId"
          @cancel-diag-title-change="changeDiagTitle(false)"
        ></DiagTitleChangeModal>
      </transition>
    </template>

    <!-- 年度更新アラート -->
    <div class="default-modal js-add-year-modal"  v-show="this.addYearAlert">
      <div class="default-modal__bg js-default-modal-close"></div>
      <div class="default-modal__content is-mini">
        <div class="default-modal__header">
          <a class="default-modal__close js-default-modal-close" href="#" @click="closeAddYearAlert"></a>
        </div>
        <div class="default-modal__body">
          <div class="l-headding is-blueline">新しい年度（{{this.currentYear}}年{{this.accountMonth}}月期）を作成します。</div>
          <ul class="l-list">
            <li>この操作を行うと最も古い年度「{{this.currentYear-4}}年{{this.accountMonth}}月期の実績」が非表示となります。</li>
            <li>実績が入力されていない新しい年度が追加されるため、カルテに表示されている人的資本に関する情報が全て空白になります。</li>
            <li>この操作はやり直しができません。操作を行う場合は下記のボタンをクリックしてください。</li>
          </ul>

          <div class="default-modal__footer" style="text-align: center;">
            <div class="btn-group">
              <div class="btn-basic is-inlne js-cancel is-middle">
                <button class=" js-default-modal-close" @click="closeAddYearAlert">キャンセル</button>
              </div>
              <div class="btn-basic is-inlne is-primary is-middle"><button class=" js-default-modal-close"  @click="createNewYear">新しい年度を作成する</button></div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </main>
</template>

<script src="https://code.jquery.com/jquery-3.5.1.min.js "></script>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import LatestNoticeList from '@/components/parts/portal/notice/LatestNoticeList.vue';
import LatestNoticeForOfficeList from '@/components/parts/portal/notice/LatestNoticeForOfficeList.vue';
import LatestDiagResult from '@/components/parts/diag/LatestDiagResult.vue';
//import RoughDiagResultList from '@/components/parts/diag/RoughDiagResultList.vue';
import CorporateListModal from '@/components/pages/corporate/CorporateListModal.vue';
import DiagTitleChangeModal from '@/components/pages/diag/DiagTitleChangeModal.vue';
import CorporateFeatureInfoLabel from '@/components/parts/corporate/CorporateFeatureInfoLabel.vue';
import HumanCapitalSummary from '@/components/parts/human_capital/parts/HumanCapitalSummary.vue';
import CorporateInfo from '@/components/parts/human_capital/parts/CorporateInfo.vue';
import CorporateRank from '@/components/parts/human_capital/parts/CorporateRank.vue';

// 従業員数区分ラベル(Workplace::EMP_TYPE_* に対応)
const WS_EMP_LABELS = {
  1: '0名',
  2: '1〜9名',
  3: '10〜49名',
  4: '50〜99名',
  5: '100〜299名',
  6: '300〜1000名',
  7: '1001名以上',
};

export default {
  components: {
    Loading,
    LatestNoticeList,
    LatestNoticeForOfficeList,
    LatestDiagResult,
//    RoughDiagResultList,
    CorporateListModal,
    DiagTitleChangeModal,
    CorporateFeatureInfoLabel,
    HumanCapitalSummary,
    CorporateInfo,
    CorporateRank
  },
  computed: {
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    corpNm() {
      return this.$store.getters['diag/getCorpName'];
    },
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    isAdminUser() {
      return this.userAuthNo != 9;  // 一般ユーザ以外
    },
    isConsultant() {
      return this.corpAuthNo == 3;
    },
    manageCorpName() {
      return this.$store.getters['auth/getUser'].manageCorpNm;
    },
    isOptionDiag() {
      return this.$store.getters['diag/getIsOptionDiag'];
    },
    isProxy() {
      return this.planId == 3; // 代理店
    },
    canEditWorkplace() {
      return this.userAuthNo == 3;  // 事業場を編集できる(専門家ユーザ)
    },
    memo() {
      return this.$store.getters['diag/getMemo'];
    },
    memoOpenFlag() {
      return this.$store.getters['diag/getMemoOpenFlag'];
    }
  },
  watch:  {
    memo() {
//      this.memo = this.$store.dispatch('diag/getMemo');
    },
    diagResultId() {
      this.$store.dispatch('diag/initEachSearchForm');
    },
    async corpId() {

      // 法人切替時は事業場プレビューを閉じ、次回ホバー時に再取得する
      this.isShowWorkplaceModal = false;
      this.workplaceLoaded = false;
      this.wsWorkplaces = [];
      this.wsItems = [];
      this.wsStatuses = [];

      this.$store.dispatch('diag/setDiagResultId', null);
      await this.getLatestDiagResultForCorporate(this.corpId, this.diagResultId);

      await this.$refs.corpInfo.getCorporateFeatureInfoLabels(this.corpId);
      await this.$refs.hrSummary.changeCorpId(this.corpId);
      await this.$refs.corpRank.changeCorpId(this.corpId, this.diagResultId);

    }
  },
    filters: {
    omittedFileName(text) {
      if ( text === null ) return '';
      return text.length > 9 ? text.slice(0, 9) + "…" : text;
    },
  },
  data() {
    return {
      hash: this.$route.hash,
      isProcessing: false,
      isShowCorporateList: false,
      isDiagAvailablePlan: false,
      isAdmin: false,
      isSystemAdmin: false,
      isAllPermission: false,
      isSupple: false,
      userAuthNo: null,
      corpAuthNo: null,
      execChangeDiagTitle: false,
      corporateFeatureInfoLabels: [],
      noManageCorp: false,

      addYearAlert: false,
      currentYear: null,
      accountMonth: null,

      planId: null,

      isIpo: false,

      // 事業場情報プレビュー
      isShowWorkplaceModal: false,
      wsHideTimer: null,
      workplaceLoaded: false,
      wsWorkplaces: [],
      wsItems: [],
      wsStatuses: [],
    }
  },
  mounted() {
    this.$nextTick(function () {
      if (this.hash) {
        const refName = this.hash.replace('#', '')
        this.scrollToAnchorPoint(refName)
      }
    })

    jQuery(function ($) {
      $('[data-tooltip]').each(function(id) {
        var _text = $(this).attr('data-tooltip');
        var _pos = $(this).attr('data-tooltip-pos');
        var _posclass = '';
        if(_pos == "right") {
          _posclass = 'is-right';
        }
        if(_pos == "bottom") {
          _posclass = 'is-bottom';
        }
        $(this).append('<span class="tooltip ' +_posclass + '">' + _text + '</span>');
      });

      $('[data-tooltip]').on('mouseover', function(){
        event.stopPropagation();  // 他の要素へのイベント伝播を停止
        var _h = $(this).children('.tooltip').height();
        _h += 15;
        if (!$(this).children('.tooltip').hasClass('is-right')) {
            $(this).children('.tooltip').css('top', -(_h));
        }
        if ($(this).children('.tooltip').hasClass('is-bottom')) {
            $(this).children('.tooltip').css('top', 'auto');
            $(this).children('.tooltip').css('bottom', -(_h));
        }
        $(this).children('.tooltip').fadeIn();//.fadeToggle(200);
      });
      $('[data-tooltip]').on('mouseleave', function(){
        $(this).children('.tooltip').fadeOut();
      });
      $(document).on('click', function() {
          $('.tooltip').fadeOut(200); // 画面のどこかがクリックされたときにツールチップを隠す
      });
    })
  },
  created: async function() {
    this.isProcessing = true;
    const authority = await this.$store.dispatch('auth/getAuthority');
    this.isDiagAvailablePlan = authority.isDiagAvailablePlan;
    this.isAdmin = authority.isAdmin;
    this.isAllPermission = authority.isAllPermission;
    this.isSystemAdmin = authority.isSystemAdmin;
    this.userAuthNo = authority.userAuthNo;
    this.corpAuthNo = authority.corpAuthNo;
    this.isSupple = authority.isSupple;
    this.planId = authority.planId;
    this.noManageCorp = authority.noManageCorp;

    if (this.isAllPermission || this.isSystemAdmin) {
      this.$nextTick(() => {
        this.isProcessing = false;
      });
      return;
    }

    if ( !this.noManageCorp ) {
      if (!this.corpId) {
        if (!authority.isAdmin) {
          this.$store.dispatch('diag/setCorpId', authority.corpId);
        } else {
          let corporateList = await this.getCorpList();
          this.$store.dispatch('diag/setCorpId', corporateList[0].corpId);
        }
      }
      if (!this.isSupple) {
        await this.$refs.latestDiagResult.getLatestDiagResultForCorporate(this.corpId, this.diagResultId);
        await this.getCorporateFeatureInfoLabels(this.corpId);
        await this.$refs.hrSummary.changeCorpId(this.corpId);
        await this.$refs.corpRank.changeCorpId(this.corpId, this.diagResultId);
      }
  //    this.$refs.roughDiagResultList.getRoughDiagResultHistory(this.corpId);
    }
    this.$nextTick(() => {
      this.isProcessing = false;
    });
  },
  methods: {
    /**
     * メモ編集ボタンクリック時処理
     */
    async memoOpen(){
      this.$store.dispatch('diag/setMemoOpenFlag', !this.memoOpenFlag);
    },
    async getLatestDiagResultForCorporate(corpId, diagResultId = null) {
      if (corpId) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/diag/getLatestDiagResultForCorporate', {
          corpId: corpId,
          diagResultId: diagResultId,
        });
        if (res.status==200) {
          this.$store.dispatch('diag/setDiagResultId', res.data.latestDiagResult.diagResultId);
          this.$store.dispatch('diag/setCorpName', res.data.latestDiagResult.corpNm);
          this.isIpo = res.data.latestDiagResult.isIpo;
//          await this.$refs.corpRank.changeCorpId(this.corpId, this.diagResultId);
        }else{
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    },


async closeAddYearAlert() {
      this.addYearAlert = false;
    },
    async createNewYear() {
      this.addYearAlert = false;
      this.$refs.hrSummary.createNewYear();
    },
    async emitShowAddYearAlert(params) {
       this.addYearAlert = params.addYearAlert;
       this.accountMonth= params.accountMonth;
       this.currentYear= params.currentYear;
    },
    async emitSaveCorpSetting(params) {
      if (params.message) this.$refs.corpInfo.getCorporateFeatureInfoLabels(this.corpId);
    },
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth' })
    },
    async getCorporateFeatureInfoLabels(corpId) {
      if (corpId) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/hr/getCorporateFeatureInfoLabels', {
          corpId: corpId,
        });
        if (res.status==200) {
          this.corporateFeatureInfoLabels = res.data.corporateFeatureInfoLabels;
        }else{
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    },
    async emitSelectCorpList(params) {

      this.isProcessing = false;
      this.$store.dispatch('diag/setCorpId', params.corpId);
      this.$store.dispatch('diag/setCorpName', params.corpNm);

      if (!this.isSupple) {
        await this.$refs.latestDiagResult.getLatestDiagResultForCorporate(params.corpId, null);
        await this.getCorporateFeatureInfoLabels(this.corpId);
        await this.$refs.hrSummary.changeCorpId(this.corpId);
        await this.$refs.corpRank.changeCorpId(this.corpId, this.diagResultId);
      }
//      await this.$refs.roughDiagResultList.getRoughDiagResultHistory(params.corpId);

      this.$nextTick(() => {
        this.isProcessing = false;
      });
    },
    // --- 事業場情報プレビュー(ホバー) ---
    async onWorkspaceEnter() {
      clearTimeout(this.wsHideTimer);
      if (!this.workplaceLoaded) {
        await this.fetchWorkplacePreview();
      }
      this.isShowWorkplaceModal = true;
    },
    onFeatureEnter() {
      clearTimeout(this.wsHideTimer);
      this.isShowWorkplaceModal = false;
    },
    onCompanyEnter() {
      clearTimeout(this.wsHideTimer);
    },
    onCompanyLeave() {
      this.wsHideTimer = setTimeout(() => {
        this.isShowWorkplaceModal = false;
      }, 150);
    },
    async fetchWorkplacePreview() {
      if (!this.corpId) return;
      let res = await this.$axios.post('/ld/api/workplace/getWorkplaceData', { corpId: this.corpId });
      if (res) {
        this.wsWorkplaces = res.data.workplaces;
        this.wsItems = res.data.notificationItems;
        this.wsStatuses = res.data.statuses;
        this.workplaceLoaded = true;
      }
    },
    wsEmpLabel(employeesType) {
      return WS_EMP_LABELS[employeesType] || '';
    },
    // 読み取り専用ラベル: 不要 / 対応済 / 未対応(未対応はalert)/ 未選択は—
    wsCell(workplaceId, itemId) {
      const s = this.wsStatuses.find(
        (x) => x.workplaceId === workplaceId && x.workplaceNotificationItemId === itemId
      );
      if (!s || s.necessity == null) return { text: '—', cls: '', alert: false };
      if (s.necessity === 2) return { text: '不要', cls: 'is-na', alert: false };
      if (s.status === 1) return { text: '対応済', cls: 'is-done', alert: false };
      return { text: '未対応', cls: 'is-pending', alert: true };
    },
    goWorkplaceList() {
      this.$store.dispatch('user/setCorpId', this.corpId);
      this.$router.push({ name: 'workplace-list', query: { corpId: this.corpId } });
    },
    goNewDiag() {
      const params = {};
      this.$router.push({ name: 'diag-course-select', params: params });
    },
    showCorporateList(value) {
      this.isShowCorporateList = value;
    },
    async getCorpList() {
      let res = await this.$axios.post('/ld/api/corporate/getClientCorporateList', {});
      if (res) {
        return res.data.corporateList;
      }
    },
    async getClientCorpId() {
      let res = await this.$axios.post('/ld/api/corporate/getClientCorpId', {});
      if (res) {
        return res.data.corpId;
      }
    },
    changeDiagTitle(value) {
      this.execChangeDiagTitle = value;
    },

    /** システム管理者用 */
    async goHumanCapitalMaster() {
      const params = {};
      this.$router.push({ name: 'human-capital-list', params: params });
    },

    goCorporateList() {
      const params = {};
      this.$router.push({ name: 'corporate-list', params: params });
    },
    goCorporate() {
      // ここでuserのsetCorpIdに設定して遷移する
      this.$store.dispatch('user/setCorpId', this.corpId);
      this.$router.replace({ name: 'corporate-edit', query: { corpId: this.corpId } });
    },
    goDiagMaster() {
      const params = {};
      this.$router.push({ name: 'master-top', params: params });
    },
    goGuideList() {
      const params = {};
      this.$router.push({ name: 'guide-list', params: params });
    },
    goTrialEntryList() {
      const params = {};
      this.$router.push({ name: 'trial-entry-list', params: params });
    },
    goSolutionMasterList() {
      const params = {};
      this.$router.push({ name: 'solution-master-list', params: params });
    },
    goNoticeList() {
      const params = {};
      this.$router.push({ name: 'notice-list', params: params });
    },
    // 人的資本
    async goHumanCapital() {
      this.$router.replace({path: '/hr/'+this.corpId+'/topparam'});
    },
    async goDiagTop() {
      if ( this.diagResultId != null ) {
        this.$router.replace({path: '/diag/'+this.corpId+'/'+this.diagResultId+'/topparam'});
      }else{
        let diagResultId = await this.getLatestDiagResultId(this.corpId);
        if ( diagResultId > 0 ) {
          this.$router.replace({path: '/diag/'+this.corpId+'/'+diagResultId+'/topparam'});
        }else{
          const params = {};
          this.$router.push({ name: 'diag-top', params: params });
        }
      }
    },
    async goTop() {
      this.$router.replace({name: 'top', hash: 'section01'});
    },
    goRoughDiagTop() {
      const params = {};
      this.$router.push({ name: 'rough-diag-list', params: params });
    },
    async getLatestDiagResultId(corpId) {
      this.isRendering = true;
      this.isProcessing = true;

      if (corpId) {
        let res = await this.$axios.post('/ld/api/diag/getLatestDiagResultId', {
          corpId: corpId
        });
        if (res.status) {
          this.isRendering = false;
          this.isProcessing = false;
          return res.data.diagResultId;
        }else{
          this.isRendering = false;
          this.isProcessing = false;
        }
      }
    },
    goInput() {
      this.$store.dispatch('user/setCorpId', null);
      this.$router.push({ name: 'corporate-new' });
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
  }
}
</script>

<style scoped>
/* 事業場情報プレビュー(.ws-modal は position:absolute / top:100% のため相対親が必要) */
.title1.is-company {
  position: relative;
}
.corplist-fade-enter-active {
  transition: all .2s ease;
}
.corplist-fade-leave-active {
  transition: all .2s ease;
}
.corplist-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.corplist-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.diagtitlechange-fade-enter-active {
  transition: all .2s ease;
}
.diagtitlechange-fade-leave-active {
  transition: all .2s ease;
}
.diagtitlechange-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.diagtitlechange-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

</style>
